
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';

@Component({
	props:{
		hideOverflow: {
			type: Boolean,
			required: false,
			default: false,
		},
		level: {
			type: Number,
			required: true,
		},
		levelCount: {
			type: Number,
			required: true,
		},
	},
})
export default class LevelDrill extends Vue {


}
